import React from 'react';
import './AppointmentTodos.scss';
import QuickCreateTodoCard from 'Components/QuickCreateTodoCard';
import RequestBuilder, { comparisonTypes } from 'Resources/RequestBuilder';
import BemClass from '@upsales/components/Utils/bemClass';
import Appointment from 'App/resources/Model/Appointment';
import Activity, { ActivityOnlyRequiredForSave } from 'App/resources/Model/Activity';
import { useSelf, useTodoTypes } from 'App/components/hooks/appHooks';
import ActivityResource from 'Resources/Activity';
interface Props {
	appointment: Appointment;
	canCreate?: boolean;
}
const AppointmentTodos = ({ appointment, canCreate = true }: Props) => {
	const todoType = useTodoTypes().TODO?.id;
	const self = useSelf()!;

	const onSave = (createData: Activity) => {
		let data: ActivityOnlyRequiredForSave;
		if (createData?.id) {
			data = { ...createData };
		} else {
			data = {
				...createData,
				client: appointment.client,
				contacts: appointment.contacts,
				activityType: { id: todoType! },
				parentAppointmentId: appointment.id,
				users: [{ id: self.id }]
			};

			if (appointment.project) {
				data.project = { id: appointment.project.id };
			}
		}
		return ActivityResource.save(data);
	};
	const fetchTodos = () => {
		const rb = new RequestBuilder();
		rb.addFilter({ field: 'parentAppointmentId' }, comparisonTypes.Equals, appointment.id);
		rb.addSort({ field: 'priority' }, false);
		return ActivityResource.find(rb.build());
	};
	if (!appointment) {
		return null;
	}
	const classes = new BemClass('AppointmentTodos');
	return (
		<div className={classes.b()}>
			<QuickCreateTodoCard onSave={onSave} fetchTodos={fetchTodos} hideRelation canCreate={canCreate} />
		</div>
	);
};

export default AppointmentTodos;
